import Vue from "vue";

export default {
	state: {
		emailActivity: [],
		emailPagination: {}
	},
	mutations: {
		setEmailActivityOnState(state, emailActivity) {
			state.emailActivity = emailActivity;
		},
		setEmailPaginationOnState(state, emailPagination) {
			state.emailPagination = emailPagination;
		}
	},
	actions: {
		getEmailActivity({ commit }, filter) {
			this.state.loading = true;
			return new Promise((resolve) => {
				Vue.prototype.$http
					.post("email/activity", filter)
					.then((response) => {
						this.state.loading = false;
						commit("setEmailActivityOnState", response.data.data.emailActivityList);
						commit("setEmailPaginationOnState", response.data.data.pagination);
						resolve(response);
					})
					.catch(() => {
						this.state.loading = false;
					});
			});
		}
	},
	getters: {
		emailActivity({ emailActivity }) {
			return emailActivity;
		},
		emailPagination({ emailPagination }) {
			return emailPagination;
		}
	}
};
